<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    label="Nome"
                    v-model="model.nome"
                    :validations="validations.nome"
                    uppercase
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, error } from '@/mixins'

export default {
    mixins: [ repository, stringCase, object, error ],
    props: {
        id: { type: Number }
    },
    data: () => ({
        repositories: {
            convenioMedico: null,
        },
        model: {
            nome: '',
        },
    }),
    computed: {
        validations() {

            return {
                nome: {
                    required: true,
                    max: 50,
                },
            }
        },
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            if (this.id) {

                this.setLoading()

                this.repositories.convenioMedico.edit(this.id)
                    .then(({ data }) => this.model.nome = data.model.nome)
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const request = this.id
                        ? this.repositories.convenioMedico.update(this.id, this.prepareData())
                        : this.repositories.convenioMedico.store(this.prepareData())

                    request
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            return this.camelObjectKeysToSnakeRecursive(this.clone(this.model))
        },
    },
    created() {

        this.repositories.convenioMedico = this.getConectaSusRepository('cadastro.sujeitoAtencao.convenioMedico')

        this.load()
    }
}
</script>